const qualityTab = (() => {
  if (document.querySelector("body#pageQuality") !== null) {



    let __yo = document.querySelector('#__yo');
    let tabWraps = __yo.querySelectorAll('.js-tab-wrap');
    let tabCntntWrapOuters = __yo.querySelectorAll('.js-tab-cntnt-wrap-outer');


    tabWraps.forEach((element, index) => {

      let tabBoxs = tabWraps[index].querySelectorAll('.js-tab-box');
      let tabCntntWraps = tabCntntWrapOuters[index].querySelectorAll('.js-tab-cntnt-wrap');

      tabBoxs.forEach((element2, index2) => {

        element2.addEventListener('click', () => {

          for (let i = 0; i < tabBoxs.length; i++) {
            tabBoxs[i].classList.remove('is-act');
            tabCntntWraps[i].classList.remove('is-act');
          }

          tabBoxs[index2].classList.add('is-act');
          tabCntntWraps[index2].classList.add('is-act');

        });

      });

      tabBoxs[0].classList.add('is-act');
      tabCntntWraps[0].classList.add('is-act');

    });



  }
})()
export default qualityTab;